import { Hero } from "@/components/Hero";
import { Features } from "@/components/Features";
import { StoryPreview } from "@/components/StoryPreview";
import { CallToAction } from "@/components/CallToAction";
import { CreativeSuite } from "@/components/CreativeSuite";
import { Button } from "@/components/ui/button";
import { useNavigate, useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { Session } from "@supabase/supabase-js";
import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { logger } from "@/lib/logger"; // Import the logger utility

const Index = ({ session }: { session: Session | null }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [referralCode, setReferralCode] = useState<string | null>(null);

  useEffect(() => {
    // Environment verification using logger instead of logger.log
    if (import.meta.env.DEV) {
      logger.info('Running in DEVELOPMENT mode');
      logger.info('Supabase URL:', import.meta.env.VITE_SUPABASE_URL);
    } else {
      logger.info('Running in PRODUCTION mode');
      logger.info('Supabase URL:', import.meta.env.VITE_SUPABASE_URL);
    }

    // Debug cookie values using logger
    logger.debug("Index page loaded. Cookie values:");
    logger.debug("preferredLanguage:", Cookies.get("preferredLanguage"));
    logger.debug("All cookies:", document.cookie);

    const searchParams = new URLSearchParams(location.search);
    const refCode = searchParams.get('ref');
    
    if (refCode) {
      setReferralCode(refCode);
      logger.debug("Referral code detected on landing page:", refCode);
      
      // Store the referral code in localStorage for persistence
      localStorage.setItem('referralCode', refCode);
    }
  }, [location]);

  const handleLogout = async () => {
    await supabase.auth.signOut();
  };

  const handleLogin = () => {
    // Pass referral code when navigating to auth page
    const storedRefCode = referralCode || localStorage.getItem('referralCode');
    if (storedRefCode) {
      navigate(`/auth?ref=${storedRefCode}`);
    } else {
      navigate('/auth');
    }
  };

  return (
    <div className="min-h-screen">
      {session && (
        // User is logged in
        <div className="absolute top-4 right-4 z-50 flex gap-4 items-center">
          <span className="text-white">Welcome, {session.user.email}</span>
          <Button
            onClick={handleLogout}
            variant="outline"
            className="border-white text-white hover:bg-white/20"
          >
            Logout
          </Button>
        </div>
      )}
      
      <Hero />
      <CreativeSuite />
      {/* <Features /> */}
      <StoryPreview />
      <CallToAction />
    </div>
  );
};

export default Index;
